// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file trusted_roles/trusted_roles.proto (package trusted_roles, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message trusted_roles.GetTrustedRolesRequest
 */
export type GetTrustedRolesRequest = {
/**
 * @generated from field: string product = 1;
 */
product?: string;
}
;
/**
 * @generated from message trusted_roles.GetTrustedRolesResponse
 */
export type GetTrustedRolesResponse = {
/**
 * @generated from field: repeated string trusted_roles = 1;
 */
trustedRoles?: string[];
/**
 * @generated from field: string role_arn = 2;
 */
roleArn?: string;
}
;
/**
 * @generated from message trusted_roles.CreateTrustedRolesRequest
 */
export type CreateTrustedRolesRequest = {
/**
 * @generated from field: string product = 1;
 */
product?: string;
/**
 * @generated from field: repeated string role_names = 2;
 */
roleNames?: string[];
/**
 * @generated from field: trusted_roles.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message trusted_roles.RoleStatus
 */
export type RoleStatus = {
/**
 * @generated from field: string role = 1;
 */
role?: string;
/**
 * @generated from field: string message = 2;
 */
message?: string;
}
;
/**
 * @generated from message trusted_roles.CreateTrustedRolesResponse
 */
export type CreateTrustedRolesResponse = {
/**
 * @generated from field: repeated trusted_roles.RoleStatus success_roles = 1;
 */
successRoles?: RoleStatus[];
/**
 * @generated from field: repeated trusted_roles.RoleStatus invalid_roles = 2;
 */
invalidRoles?: RoleStatus[];
/**
 * @generated from field: repeated trusted_roles.RoleStatus skipped_roles = 3;
 */
skippedRoles?: RoleStatus[];
/**
 * @generated from field: repeated trusted_roles.RoleStatus error_roles = 4;
 */
errorRoles?: RoleStatus[];
}
;
/**
 * @generated from message trusted_roles.RemoveTrustedRolesRequest
 */
export type RemoveTrustedRolesRequest = {
/**
 * @generated from field: string product = 1;
 */
product?: string;
/**
 * @generated from field: repeated string role_names = 2;
 */
roleNames?: string[];
/**
 * @generated from field: trusted_roles.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message trusted_roles.RemoveTrustedRolesResponse
 */
export type RemoveTrustedRolesResponse = {
/**
 * @generated from field: repeated trusted_roles.RoleStatus success_roles = 1;
 */
successRoles?: RoleStatus[];
/**
 * @generated from field: repeated trusted_roles.RoleStatus skipped_roles = 2;
 */
skippedRoles?: RoleStatus[];
/**
 * @generated from field: repeated trusted_roles.RoleStatus error_roles = 3;
 */
errorRoles?: RoleStatus[];
}
;
/**
 * @generated from message trusted_roles.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc trusted_roles.TrustedRolesService.GetTrustedRoles
 */
export const TrustedRolesService_GetTrustedRoles = new RPC<GetTrustedRolesRequest,GetTrustedRolesResponse>("GET", "/getTrustedRoles");
/**
 * @generated from rpc trusted_roles.TrustedRolesService.CreateTrustedRoles
 */
export const TrustedRolesService_CreateTrustedRoles = new RPC<CreateTrustedRolesRequest,CreateTrustedRolesResponse>("POST", "/createTrustedRoles");
/**
 * @generated from rpc trusted_roles.TrustedRolesService.RemoveTrustedRoles
 */
export const TrustedRolesService_RemoveTrustedRoles = new RPC<RemoveTrustedRolesRequest,RemoveTrustedRolesResponse>("POST", "/removeTrustedRoles");
